export default __webpack_public_path__ + "static/media/1536.2f06b326.png";